import Proxy from './Proxy';

class MainImageProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('api/settings/info/main-image', parameters);
  }

  saveList(item) {
    return this.submit('post', `/${this.endpoint}/save-list`, item );
  }  

  saveDelay( delay ) {
    return this.submit('post', `/${this.endpoint}/save-delay`, delay );
  }  


}

export default MainImageProxy;
